import { Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

export const TextEdit = ({ content, onSaveChange = () => {}, ...props }) => {
  const [isEditing, setIsEditing] = useState(false);
  const paragraphRef = useRef(null);
  const [originalContent, setOriginalContent] = useState(content);

  // When starting to edit, store the original content for potential cancellation
  const startEditing = () => {
    if (!isEditing) {
      setOriginalContent(content);
      setIsEditing(true);
    }
  };

  // Update content when prop changes and we're not editing
  useEffect(() => {
    if (!isEditing && paragraphRef.current) {
      paragraphRef.current.innerHTML = content;
    }
  }, [content, isEditing]);

  useEffect(() => {
    if (paragraphRef.current) {
      paragraphRef.current.innerHTML = content;
    }
  }, [content]);
  // Handle click outside to save
  useEffect(() => {
    function handleClickOutside(event) {
      const target = event.target;
      // Don't trigger for clicks on the action buttons
      const isActionButton =
        target.nodeName === "BUTTON" ||
        target.nodeName === "svg" ||
        target.nodeName === "path";

      if (
        paragraphRef.current &&
        !paragraphRef.current.contains(target) &&
        isEditing &&
        !isActionButton
      ) {
        saveChanges();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditing]);

  const saveChanges = () => {
    if (paragraphRef.current) {
      const newContent = paragraphRef.current.innerHTML;
      if (newContent !== content) {
        onSaveChange(newContent);
      }
      setIsEditing(false);
    }
  };

  return (
    <Typography
      ref={paragraphRef}
      contentEditable={true}
      suppressContentEditableWarning={true}
      onFocus={startEditing}
      dangerouslySetInnerHTML={{ __html: content }}
      {...props}
    />
  );
};
